import type { MessageMenuItem } from "../../../types";

export const mockMenuItems: MessageMenuItem[] = [
  {
    id: "mock.explain",
    kind: "action",
    label: "📚 Explain It More Clearly",
    meta: { description: "Add more details to make it understandable" },
  },
  {
    id: "mock.concise",
    kind: "action",
    label: "✂️ Make It More Concise",
    meta: { description: "Remove unnecessary words" },
  },
  {
    id: "mock.practical",
    kind: "action",
    label: "💡 Apply It Practically",
    meta: { description: "Suggest real-world usage" },
  },
  {
    id: "mock.deeper",
    kind: "action",
    label: "🔍 Go Deeper",
    meta: { description: "Add advanced details" },
  },
  {
    id: "mock.focus",
    kind: "action",
    label: "🎯 Focus on Key Insights",
    meta: { description: "Highlight the main points" },
  },
];
